import { DataVizContainerViewConfigWithStateManager } from '../../../common/types';
import {
  OverTimeUnsegmentedVizData,
  OverTimeUnsegmentedVizExternalProps,
} from '../../types';
import { overTimeUnsegmentedBarChartDataToUiComponentProps } from './dataToUiComponentProps';
import {
  OverTimeUnsegmentedBarChartActions,
  OverTimeUnsegmentedBarChartState,
  OverTimeUnsegmentedBarChartUiComponentProps,
} from './types';
import { OverTimeUnsegmentedBarChartUiComponent } from './UiComponent';
import { useOverTimeUnsegmentedBarChartStateManager } from './useStateManager';

export const overTimeUnsegmentedBarChartViewConfig: DataVizContainerViewConfigWithStateManager<
  OverTimeUnsegmentedVizData,
  OverTimeUnsegmentedVizExternalProps,
  OverTimeUnsegmentedBarChartUiComponentProps,
  OverTimeUnsegmentedBarChartState,
  OverTimeUnsegmentedBarChartActions
> = {
  hasStateManager: true,
  useStateManager: useOverTimeUnsegmentedBarChartStateManager,
  dataToUiComponentProps: overTimeUnsegmentedBarChartDataToUiComponentProps,
  UiComponent: OverTimeUnsegmentedBarChartUiComponent,
};
